/*# sourceMappingURL=sip-config-table-actions.component-DDRBVCGY.css.map */
